import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {PageSignalStore} from '../../store/page/page.signal-store';


/**
 * Spinner component showing a spinner in the upper center of the screen, including a semitransparent white
 * layover. It's appearance is controlled by a loading boolean in the NGRX-store.
 */
@Component({
  selector: 'ucs-spinner',
  templateUrl: './spinner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  protected readonly pageSignalStore = inject(PageSignalStore);
}
